import { Outlet } from "react-router-dom";
import TicketsKanban from "./TicketsKanban";
import TicketDetailPage from "./TicketDetailPage";
import TicketDetailPageV2 from "./TicketDetailPageV2";
import TicketCategoryList from "./TicketCategories/TicketCategoryList";
import TicketCategoryForm from "./TicketCategories/TicketCategoryForm";
import ResponseTemplateList from "./ResponseTemplates/ResponseTemplateList";
import ResponseTemplateForm from "./ResponseTemplates/ResponseTemplateForm";
import TicketsMap from "./TicketsMap";

export const adminTicketsRoutes = [
  {
    path: "tickets",
    element: Outlet,
    children: [
      {
        path: "",
        element: TicketsKanban,
      },
      {
        path: "list",
        element: TicketsKanban,
      },
      // Карта обращений по филиалам. Объявлена до :id, чтобы строка "map"
      // не интерпретировалась как ID тикета.
      {
        path: "map",
        element: TicketsMap,
      },
      // Категории объявлены до :id, чтобы строка "categories" не уходила в детальную страницу.
      {
        path: "categories",
        element: TicketCategoryList,
      },
      {
        path: "categories/add",
        element: TicketCategoryForm,
      },
      {
        path: "categories/edit/:id",
        element: TicketCategoryForm,
      },
      // Шаблоны ответов (canned replies). Объявлены до :id по тем же причинам.
      {
        path: "templates",
        element: ResponseTemplateList,
      },
      {
        path: "templates/add",
        element: ResponseTemplateForm,
      },
      {
        path: "templates/edit/:id",
        element: ResponseTemplateForm,
      },
      // Детальная страница обращения — заменяет прежний модальный Dialog.
      {
        path: "new",
        element: TicketDetailPage,
      },
      // Новая версия детальной страницы (двухколоночный воркспейс).
      // Объявлена до :id, чтобы /:id не перехватывал "new" и "v2"-маршруты.
      {
        path: ":id/v2",
        element: TicketDetailPageV2,
      },
      {
        path: ":id",
        element: TicketDetailPageV2,
      },
    ],
  },
];
